// 轨迹线默认配置

/**
 * 创建路径
 * @param map 地图实例
 * @param path 路径参数提供诸如 [[116.478935,39.997761]]这样的轨迹点坐标
 * @returns {AMap.Polyline}
 */
export const createPolyLine = (map, path) => {
  // [AMap removed] Original implementation used AMap.Polyline
  // [AMap removed] return new AMap.Polyline({ map: map, path: path, showDir: true, strokeColor: '#28F', strokeWeight: 6 })
  return null
}
